/**
 * プロジェクトの定数
 */
export namespace CommonConst {

    /**
     * サーバのパス
     */
    export const SERVER_PATH: string = '/back';

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/CommonConst.ts
 **/